/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/5/2023
 */

import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { apiSlice } from "./Slices/apiSlice";
import authReducer from "./Slices/authSlice";
import categoryReducer from "./Slices/categorySlice";
import currencyReducer from "./Slices/currencySlice";
import userReducer from "./Slices/userSlice";
import customerReducer from "./Slices/customerSlice";
import roleReducer from "./Slices/brSlice";
import privilegeReducer from "./Slices/privilegeSlice";
import brPrivReducer from "./Slices/brPrivSlice";
import restaurantReducer, {
  RESTAURANT_STORAGE_KEY,
  hydrateFromStorage,
} from "./Slices/restaurantSlice";
import deliveryOrdersReducer, {
  DELIVERY_ORDERS_STORAGE_KEY,
  hydrateDeliveryFromStorage,
} from "./Slices/deliveryOrdersSlice";

export const RootStore = configureStore({
    reducer: {
      auth: authReducer,
      user: userReducer,
      customer: customerReducer,
      category: categoryReducer,
      currency: currencyReducer,
      roles: roleReducer,
      privilege: privilegeReducer,
      brPriv: brPrivReducer,
      restaurant: restaurantReducer,
      deliveryOrders: deliveryOrdersReducer,
      
      [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(apiSlice.middleware),
});

setupListeners(RootStore.dispatch)

// Keep the Restaurant POS and Kitchen Display screens in sync across tabs.
if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === RESTAURANT_STORAGE_KEY && event.newValue) {
      try {
        RootStore.dispatch(hydrateFromStorage(JSON.parse(event.newValue)));
      } catch (err) {
        // ignore malformed payloads
      }
    }

    if (event.key === DELIVERY_ORDERS_STORAGE_KEY && event.newValue) {
      try {
        RootStore.dispatch(hydrateDeliveryFromStorage(JSON.parse(event.newValue)));
      } catch (err) {
        // ignore malformed payloads
      }
    }
  });
}